export default __webpack_public_path__ + "static/media/home_icon.66f0c159.svg";